import React from 'react';  // import the React library
import '../App.css'; // import your CSS file
import { motion } from 'framer-motion';
import BioLine from '../articleComponents/bioLine.js'; // import your CSS file
import Connect from '../articleComponents/connect';
import SocialMedia from '../articleComponents/SocialMedia';
import MetaTags from '../mainPageComponents/MetaTags';
import Landscape from "../images/landscape.jpg";
import Image from '../mainPageComponents/image.js';
import TraversePosts from '../articleComponents/navigation';

const today = new Date("1, 10, 2021").toLocaleDateString('en-US', {  
  day:   'numeric',
  month: 'short',
  year:  'numeric',
  weekday: 'long'
});

function theRightSide() {
    return (
        <motion.div className="articleStyle"
        initial={{ opacity: 0 }}
animate={{opacity: 1 }}
exit={{ opacity: 0}}
transition={{duration: .4}}
>

<MetaTags title="Go with G-d" desc="The real outrage didn't occur on January 6 in the American Congress Building. It occured 3 days eariler. All of us must choose which side we are on. Let's go with G-d!" 
URL="https://highway-60.firebaseapp.com/articles/go-with-God" imageURL={Landscape} />

        <h1>Go with G-d</h1>

<Image picURL={Landscape} />

<BioLine />
<p>{today}</p>


<div style={{textAlign: "left", marginTop: "5px", marginBottom: "20px"}}>
<SocialMedia url="https://highway-60.firebaseapp.com/articles/go-with-God" title="Go with G-d" hashtag="#highway60" hashtagArray={["writing", "Israel"]} 
via="TheHighway60" desc="The real outrage didn't occur on January 6 in the American Congress Building. It occured 3 days eariler. All of us must choose which side we are on. Let's go with G-d!" />
</div>

<p>
Israel National News just published an article I wrote. A proud resident of Afula in Northern Israel, and a former New Yorker of 28 years, I see both inside and outside the box.
</p>

<p>
I don't pull my punches on this one. 
</p>

<p>
Enjoy. You can view it <a href="https://www.israelnationalnews.com/News/News.aspx/294631" target="_blank">right here</a>.
</p>


<TraversePosts prevURL="/articles/put-on-your-helmet" nextURL="/articles/a-state-is-born"/>

<Connect />
</motion.div>
  );
}

export default theRightSide;
